import React, { useState, useEffect } from 'react';
import './ErrorMessage.css'; 

interface ErrorMessageProps {
  message: string;
  duration?: number;
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({ message, duration = 3000 }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (message) {
      console.error(message);
      setIsVisible(true);

      const timer = setTimeout(() => {
        setIsVisible(false);
      }, duration);

      return () => clearTimeout(timer);
    }
  }, [message, duration]);

  return (
    <div className={`error-message ${isVisible ? 'show' : ''}`}>
      {message}
    </div>
  );
};

export default ErrorMessage;